import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["FileImport", "Details", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.FileImport.Model.Page", [], Page, () => [[], [["Item", int32_type]], []]);
}

